module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginMode"
  }, [_c('div', {
    staticClass: "con"
  }, [_c('div', {
    staticClass: "userPortrait"
  }, [_c('img', {
    attrs: {
      "src": _vm.userImg || 'https://static.qxiu.com/h5/img/static/default2.png'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "userName"
  }, [_vm._v(_vm._s(_vm.userNick || ''))]), _vm._v(" "), (_vm.wxLogin && !_vm.isxiaoxiong) ? _c('a', {
    staticClass: "btnLogin",
    attrs: {
      "href": 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbdf212b5475d03c2&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3floginType%3dwechatGZH%26oemid%3D201' + _vm.hrefstr + '%26target%3dweblive%26toUrl%3d' + _vm.protocol + '%3a%2f%2fh5.qxiu.com&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect'
    }
  }, [_vm._v("微信登录")]) : _vm._e(), _vm._v(" "), (_vm.wxLogin && _vm.isxiaoxiong) ? _c('a', {
    staticClass: "btnLogin",
    attrs: {
      "href": 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbdf212b5475d03c2&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fdlcallback%3floginType%3dwechatGZHDL%26oemid%3D43' + _vm.hrefstr + '%26target%3dweblive%26toUrl%3d' + _vm.protocol + '%3a%2f%2fh5.qxiu.com&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect'
    }
  }, [_vm._v("微信登录")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dividLine"
  }, [_c('span'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.wxLogin ? '其他' : '') + "登录方式")]), _vm._v(" "), _c('span')]), _vm._v(" "), (!_vm.isxiaoxiong) ? _c('div', {
    staticClass: "loginEntry"
  }, [_c('a', {
    attrs: {
      "href": 'https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=100717093&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3fjumpUrl%3dhttp%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fweblivelogin%26oemid%3D201' + _vm.hrefstr + '%26toUrl%3d' + _vm.protocol + '%3a%2f%2fh5.qxiu.com%2findex.html&scope=get_user_info'
    }
  }, [_c('i', {
    staticClass: "iconfont qq"
  }, [_vm._v("")])]), _vm._v(" "), (_vm.isShowLogin) ? _c('a', {
    attrs: {
      "href": 'https://api.weibo.com/oauth2/authorize?client_id=1032315493&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3floginType%3dweibo%26oemid%3d201' + _vm.hrefstr + '%26target%3dweblive%26toUrl%3d' + _vm.protocol + '%3a%2f%2fh5.qxiu.com&scope=&'
    }
  }, [_c('i', {
    staticClass: "iconfont weibo"
  }, [_vm._v("")])]) : _vm._e(), _vm._v(" "), (_vm.isShowLogin) ? _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.phoneLogin
    }
  }, [_c('i', {
    staticClass: "iconfont phone"
  }, [_vm._v("")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isxiaoxiong) ? _c('div', {
    staticClass: "loginEntry"
  }, [_c('a', {
    attrs: {
      "href": 'https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101499693&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fdlcallback%3ftarget%3dweblive%26loginType%3dqqDL%26oemid%3d43' + _vm.hrefstr + '%26toUrl%3d' + _vm.protocol + '%3a%2f%2fh5.qxiu.com%2findex.html&scope=get_user_info'
    }
  }, [_c('i', {
    staticClass: "iconfont qq"
  }, [_vm._v("")])]), _vm._v(" "), (_vm.isShowLogin) ? _c('a', {
    attrs: {
      "href": 'https://api.weibo.com/oauth2/authorize?client_id=1032315493&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fdlcallback%3ftarget%3dweblive%26loginType%3dweiboDL%26oemid%3d43' + _vm.hrefstr + '%26toUrl%3d' + _vm.protocol + '%3a%2f%2fh5.qxiu.com&scope=&'
    }
  }, [_c('i', {
    staticClass: "iconfont weibo"
  }, [_vm._v("")])]) : _vm._e(), _vm._v(" "), (_vm.isShowLogin) ? _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.phoneLogin
    }
  }, [_c('i', {
    staticClass: "iconfont phone"
  }, [_vm._v("")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "cover",
    on: {
      "click": _vm.outPop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("登录即代表您同意\n\t\t\t"), _c('a', {
    attrs: {
      "href": "https://client.qxiu.com/statement/privacy4.html"
    }
  }, [_vm._v("齐齐服务和隐私条款")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e2205a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dating/loginMode.vue
// module id = 123
// module chunks = 0